var map = {
	"src/app/pages/agent/agent.module.ngfactory": [
		"./src/app/pages/agent/agent.module.ngfactory.js",
		"default~src-app-pages-agent-agent-module-ngfactory~src-app-pages-commission-commission-module-ngfact~357ddd74",
		"default~src-app-pages-agent-agent-module-ngfactory~src-app-pages-commission-commission-module-ngfact~0adc8fb8",
		"src-app-pages-agent-agent-module-ngfactory"
	],
	"src/app/pages/auth/auth.module.ngfactory": [
		"./src/app/pages/auth/auth.module.ngfactory.js",
		"common",
		"src-app-pages-auth-auth-module-ngfactory"
	],
	"src/app/pages/commission/commission.module.ngfactory": [
		"./src/app/pages/commission/commission.module.ngfactory.js",
		"default~src-app-pages-commission-commission-module-ngfactory~src-app-pages-dashboard-dashboard-modul~fb8b17f3",
		"default~src-app-pages-agent-agent-module-ngfactory~src-app-pages-commission-commission-module-ngfact~357ddd74",
		"default~src-app-pages-agent-agent-module-ngfactory~src-app-pages-commission-commission-module-ngfact~0adc8fb8",
		"src-app-pages-commission-commission-module-ngfactory"
	],
	"src/app/pages/dashboard/dashboard.module.ngfactory": [
		"./src/app/pages/dashboard/dashboard.module.ngfactory.js",
		"default~src-app-pages-commission-commission-module-ngfactory~src-app-pages-dashboard-dashboard-modul~fb8b17f3",
		"default~src-app-pages-dashboard-dashboard-module-ngfactory~src-app-pages-wallet-wallet-module-ngfactory",
		"src-app-pages-dashboard-dashboard-module-ngfactory"
	],
	"src/app/pages/payment/payment.module.ngfactory": [
		"./src/app/pages/payment/payment.module.ngfactory.js",
		"default~src-app-pages-commission-commission-module-ngfactory~src-app-pages-dashboard-dashboard-modul~fb8b17f3",
		"default~src-app-pages-agent-agent-module-ngfactory~src-app-pages-commission-commission-module-ngfact~357ddd74",
		"src-app-pages-payment-payment-module-ngfactory"
	],
	"src/app/pages/public-work/public-work.module.ngfactory": [
		"./src/app/pages/public-work/public-work.module.ngfactory.js",
		"src-app-pages-public-work-public-work-module-ngfactory"
	],
	"src/app/pages/settings/settings.module.ngfactory": [
		"./src/app/pages/settings/settings.module.ngfactory.js",
		"default~src-app-pages-commission-commission-module-ngfactory~src-app-pages-dashboard-dashboard-modul~fb8b17f3",
		"default~src-app-pages-agent-agent-module-ngfactory~src-app-pages-commission-commission-module-ngfact~357ddd74",
		"common",
		"src-app-pages-settings-settings-module-ngfactory"
	],
	"src/app/pages/user/user.module.ngfactory": [
		"./src/app/pages/user/user.module.ngfactory.js",
		"src-app-pages-user-user-module-ngfactory"
	],
	"src/app/pages/wallet/wallet.module.ngfactory": [
		"./src/app/pages/wallet/wallet.module.ngfactory.js",
		"default~src-app-pages-commission-commission-module-ngfactory~src-app-pages-dashboard-dashboard-modul~fb8b17f3",
		"default~src-app-pages-agent-agent-module-ngfactory~src-app-pages-commission-commission-module-ngfact~357ddd74",
		"default~src-app-pages-dashboard-dashboard-module-ngfactory~src-app-pages-wallet-wallet-module-ngfactory",
		"src-app-pages-wallet-wallet-module-ngfactory"
	],
	"src/app/pages/work-template/work-template.module.ngfactory": [
		"./src/app/pages/work-template/work-template.module.ngfactory.js",
		"default~src-app-pages-commission-commission-module-ngfactory~src-app-pages-dashboard-dashboard-modul~fb8b17f3",
		"default~src-app-pages-agent-agent-module-ngfactory~src-app-pages-commission-commission-module-ngfact~357ddd74",
		"default~src-app-pages-agent-agent-module-ngfactory~src-app-pages-commission-commission-module-ngfact~0adc8fb8",
		"src-app-pages-work-template-work-template-module-ngfactory"
	],
	"src/app/pages/workspace/workspace.module.ngfactory": [
		"./src/app/pages/workspace/workspace.module.ngfactory.js",
		"default~src-app-pages-commission-commission-module-ngfactory~src-app-pages-dashboard-dashboard-modul~fb8b17f3",
		"default~src-app-pages-agent-agent-module-ngfactory~src-app-pages-commission-commission-module-ngfact~357ddd74",
		"src-app-pages-workspace-workspace-module-ngfactory"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;